<template>
  <div class="all">

    <div class="container">
      <div class="dot dot-1"></div>
      <div class="dot dot-2"></div>
      <div class="dot dot-3"></div>
    </div>
    <div class="pcShow">
      <div class="text-pc">
      Thank you! <br>Hold on while we build your personalized recommendations.
    </div>
    </div>
    <div class="mShow">
      <div class="text-m">
      Thank you! <br>Hold on while we build your personalized recommendations.
    </div>
    </div>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
        <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7"/>
        </filter>
        </defs>
    </svg> -->
  </div>
</template>

<script>
export default {
  mounted () {
    this.$store.dispatch('generateReportData')

    const device = window.innerWidth > 767? 'Web': 'Mobile'
    const email = this.$store.state.userEmail
    const productList = this.$store.state.product
    const hasProduct = this.$store.state.product.length > 0

    if(hasProduct){
      //完成问卷埋点 逐条上报
      productList.forEach(productId => {
        this.$sensors.track('FinishQuestionnaire', {
          device: device,
          email: email,
          productId: productId,
          hasProduct: hasProduct
        })
      });
    }else{
      this.$sensors.track('FinishQuestionnaire', {
        device: device,
        email: email,
        productId: [],
        hasProduct: hasProduct
      })
    }
    
    setTimeout( () => {
      this.$router.push('/introduction')
    }, 2000)
  }
}
</script>

<style scoped>
.all {
  width: 100%;
  height: 100%;
  background: #FBF3EE;
}
.text-pc {
  margin: 0 auto;
  text-align: center;
  width: 808px;
  height: 606px;
  padding-top: 514px;
  font-size: 30px;
  font-family: Helvetica;
  color: #000000;
  line-height: 40px;
}
.text-m {
  text-align: center;
  margin: 0 auto;
  padding-top: 378.5px;
  width: 256.5px;
  height: 505.5px;
  font-size: 20px;
  font-family: Helvetica;
  color: #000000;
  line-height: 27px;
}
.container {
  margin-top: 146.5px;
  width: 159.5px;
  height: 159.5px;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  filter: url('#goo');
  animation: rotate-move 2s ease-in-out infinite;
}

.dot { 
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.dot-3 {
  background-color: #f74d75;
  animation: dot-3-move 2s ease infinite, index 6s ease infinite;
}

.dot-2 {
  background-color: #10beae;
  animation: dot-2-move 2s ease infinite, index 6s -4s ease infinite;
}

.dot-1 {
  background-color: #ffe386;
  animation: dot-1-move 2s ease infinite, index 6s -2s ease infinite;
}

@keyframes dot-3-move {
  20% {transform: scale(1)}
  45% {transform: translateY(-18px) scale(.45)}
  60% {transform: translateY(-90px) scale(.45)}
  80% {transform: translateY(-90px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes dot-2-move {
  20% {transform: scale(1)}
  45% {transform: translate(-16px, 12px) scale(.45)}
  60% {transform: translate(-80px, 60px) scale(.45)}
  80% {transform: translate(-80px, 60px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes dot-1-move {
  20% {transform: scale(1)}
  45% {transform: translate(16px, 12px) scale(.45)}
  60% {transform: translate(80px, 60px) scale(.45)}
  80% {transform: translate(80px, 60px) scale(.45)}
  100% {transform: translateY(0px) scale(1)}
}

@keyframes rotate-move {
  55% {transform: translate(-50%, -50%) rotate(0deg)}
  80% {transform: translate(-50%, -50%) rotate(360deg)}
  100% {transform: translate(-50%, -50%) rotate(360deg)}
}

@keyframes index {
  0%, 100% {z-index: 3}
  33.3% {z-index: 2}
  66.6% {z-index: 1}
}
</style>